import { ActionIcon, Tooltip } from "@mantine/core";
import { IconHistory } from "@tabler/icons-react";

interface HistoryButtonProps {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

function HistoryButton({
  disabled,
  label = "Historie öffnen",
  onClick
}: HistoryButtonProps) {
  return (
    <Tooltip label={label}>
      <ActionIcon
        aria-label={label}
        disabled={disabled}
        variant="transparent"
        onClick={onClick}
      >
        <IconHistory size={16} />
      </ActionIcon>
    </Tooltip>
  );
}

export { HistoryButton, HistoryButtonProps };
